import SearchIcon from 'components/Icons/Search'
import messages from 'lang'
import React, { RefObject } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { color, fontSize, screenWidth } from 'utils'

const SearchInput = styled.div<{ historyCompact?: boolean }>`
  position: relative;

  input {
    font-weight: 600;
    font-size: ${fontSize('md')};
    line-height: 1.25rem;
    color: ${color('white')};
    background: transparent;
    border-radius: 0.5rem;
    border: 1px solid ${color('dark500')};
    padding: 0.75rem 3rem 0.75rem 1rem;
    outline: 0;
    width: 100%;
    position: relative;

    :focus {
      border-color: ${color('dark200')};
    }
    ::placeholder {
      color: ${color('grey400')};
    }
    @media only screen and (max-width: ${screenWidth('sm')}) {
      width: ${({ historyCompact }) => (historyCompact ? '9rem' : '100%')};
    }
  }
  > svg {
    position: absolute;
    right: 0;
    z-index: 1;
    top: -1px;
    fill: ${color('grey400')};
    padding: 1rem;
    box-sizing: content-box;
  }
`

type SearchProps = {
  className?: string
  historyCompact?: boolean
  icon?: React.ReactNode
  onChange: (e: any) => void
  placeholder?: string
  value: string
}

const Search = React.forwardRef(
  (
    { className, historyCompact = false, icon, onChange, placeholder, ...props }: SearchProps,
    ref
  ) => {
    const intl = useIntl()
    return (
      <SearchInput className={className} historyCompact={historyCompact}>
        {icon ?? <SearchIcon size='16px' />}
        <input
          ref={ref as RefObject<HTMLInputElement>}
          tabIndex={0}
          type='text'
          placeholder={placeholder ?? intl.formatMessage(messages.placeholder_search)}
          onChange={onChange}
          {...props}
        />
      </SearchInput>
    )
  }
)

export default Search
